<div class="form-wrapper">
    <div class="form-container">
        <div class="form-header">{{ formMainTitle }}</div>
        <div class="form-subheader">
            Instant visibility into spend, performance signals, creatives,
            strategy, and how to win. <span class="bold">Powered by POLARIS.AI™, our
            marketing LLM trained on proprietary data.</span>
        </div>
        <div class="form-third-title">{{ formThirdTitle }}</div>
        <div class="form-content">
            <div class="form-row google-signup">
                <div class="form-input">
                    <button 
                        type="button" 
                        class="input-button google-btn" 
                        [class.error]="googleControl.invalid"
                        (click)="onGoogleSignup()">
                        <img class="logo" [src]="'svg/google-logo.svg' | assetVersion" alt="Google Logo">
                        <span>Continue with Google</span>
                    </button>
                    <div class="error-message" *ngIf="googleControl.invalid">
                        Please use a work email address
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!enforceGoogleSignup">
                <div class="divider">
                    <div class="divider-line"></div>
                    <div class="divider-text">or</div>
                    <div class="divider-line"></div>
                </div>
                <div class="form-row personal-details" >
                    <div class="form-input">
                        <input
                            type="text"
                            placeholder="First Name"
                            autocomplete="given-name"
                            [formControl]="firstNameControl"
                            [class.error]="firstNameControl.invalid && firstNameControl.touched"
                            (keydown.enter)="onSubmit()">
                        <div class="error-message" *ngIf="firstNameControl.invalid && firstNameControl.touched">
                            First Name is required
                        </div>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            placeholder="Last Name"
                            autocomplete="family-name"
                            [formControl]="lastNameControl"
                            [class.error]="lastNameControl.invalid && lastNameControl.touched"
                            (keydown.enter)="onSubmit()">
                        <div class="error-message" *ngIf="lastNameControl.invalid && lastNameControl.touched">
                            Last Name is required
                        </div>
                    </div>
                </div>
                <div class="form-row email">
                    <div class="form-input">
                        <input
                            type="email"
                            placeholder="Work Email"
                            autocomplete="email"
                            [formControl]="emailControl"
                            [class.error]="emailControl.invalid && emailControl.touched"
                            (keydown.enter)="onSubmit()">
                        <div class="error-message" *ngIf="emailControl.invalid && emailControl.touched">
                            {{ getEmailErrorMessage() }}
                        </div>
                    </div>
                </div>
                <div class="legal-info">By continuing, you agree to the
                    <a (click)="openTermsOfService()">Terms of Service</a> and <a (click)="openPolicy()">Privacy Policy</a>
                </div>
                <button type="button"
                        class="submit-button"
                        [class.loading]="isLoading"
                        [class.disabled]="isLoading"
                        [disabled]="isLoading"
                        (click)="onSubmit()">
                    <span *ngIf="!isLoading">Start your free trial</span>
                    <span *ngIf="isLoading">Loading...</span>
                </button>
            </ng-container>
        </div>
    </div>
    <div *ngIf="!enforceGoogleSignup" class="login-link">Already have an account?
        <a href="/polaris" (click)="sendPostHogLoginLinkEvent()">Log In</a>
    </div> 
</div>
<div class="logo-strip">
    <span class="logo-strip-title">Trusted by<br>companies of all sizes</span>
    <div class="logo-strip-logos">
        <img [src]="'svg/salesforce-logo.svg' | assetVersion" alt="Salesforce Logo">
        <img [src]="'svg/dentsu-logo.svg' | assetVersion" alt="Dentsu Logo">
        <img [src]="'svg/teads-logo.svg' | assetVersion" alt="Teads Logo">
        <img [src]="'svg/shrm-logo.svg' | assetVersion" alt="SHRM Logo">
        <img [src]="'svg/anteriad-logo.svg' | assetVersion" alt="Anteriad Logo">
        <img [src]="'svg/campfire-logo.svg' | assetVersion" alt="Campfire Logo">
    </div>
</div>